import type {RouteObject} from 'react-router-dom';

import {loginLoader} from './loaders';

export const routes = [
  {
    path: '/login',
    loader: loginLoader,
    async lazy() {
      const {LoginPage} = await import('./pages/LoginPage');
      return {element: <LoginPage />};
    },
  },
  {
    path: '/resetPassword',
    loader: loginLoader,
    async lazy() {
      const {ResetPasswordPage} = await import('./pages/ResetPasswordPage');
      return {element: <ResetPasswordPage />};
    },
  },
  {
    path: '/login/scan',
    loader: loginLoader,
    async lazy() {
      const {LoginScanPage} = await import('./pages/LoginScanPage');
      return {element: <LoginScanPage />};
    },
  },
  {
    path: '/terms-and-conditions',
    async lazy() {
      const {TermsApprovalPage} = await import('./pages/TermsApprovalPage');
      return {element: <TermsApprovalPage />};
    },
  },
  {
    path: '/privacy-policy',
    async lazy() {
      const {PrivacyPolicyPage} = await import('./pages/PrivacyPolicyPage');
      return {element: <PrivacyPolicyPage />};
    },
  },
  {
    path: '/owner-approval-required',
    async lazy() {
      const {OwnerApprovalRequiredPage} = await import(
        './pages/OwnerApprovalRequiredPage'
      );
      return {element: <OwnerApprovalRequiredPage />};
    },
  },
  {
    path: '/unauthorized',
    async lazy() {
      const {UnauthorizedPage} = await import('./pages/UnauthorizedPage');
      return {element: <UnauthorizedPage />};
    },
  },
] as RouteObject[];
